import AccountError from './AccountError';

export default {
  path: 'kayttajatili-virhe',
  components: { content: AccountError }
};
